<template>
  <v-container fluid class="pa-6 pa-md-8">
    <Breadcrumbs
      :items="[
        { text: 'All Staff', disabled: false, href: '/admin/staffs/all' },
        {
          text: details && details._id ? details._id.name : 'Staff',
          disabled: true,
          href: ''
        },
        { text: 'Transactions', disabled: true, href: '' }
      ]"
    />
    <div class="page-head mt-2">
      <h1 class="page-head__title text-capitalize">
        {{ details && details._id ? details._id.name : "Staff Member" }}
      </h1>
      <p class="page-head__sub">Staff member profile and transaction history.</p>
    </div>

    <v-row class="mb-1">
      <v-col cols="12" md="4">
        <div class="info-card">
          <div class="info-card__avatar">
            <v-icon>mdi-account-outline</v-icon>
          </div>
          <div>
            <p class="info-card__name text-uppercase" v-if="details && details._id">
              {{ details._id.name }}
            </p>
            <p class="info-card__line" v-if="details && details._id">
              <span class="text-muted">Acc/No.</span>
              <span class="tabular">{{ details._id.accountNumber }}</span>
            </p>
            <p class="info-card__line" v-if="details && details._id">
              <span class="text-muted">Phone</span>
              <span class="tabular">{{ details._id.phone }}</span>
            </p>
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="info-card">
          <div class="info-card__avatar info-card__avatar--success">
            <v-icon>mdi-cash-multiple</v-icon>
          </div>
          <div>
            <p class="info-card__label">Overall Total Transactions</p>
            <p class="info-card__value tabular">
              {{
                details && details.totalAmount
                  ? currency(details.totalAmount)
                  : "GHS 0.00"
              }}
            </p>
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="4" v-if="date">
        <div class="info-card">
          <div class="info-card__avatar info-card__avatar--info">
            <v-icon>mdi-credit-card-outline</v-icon>
          </div>
          <div>
            <p class="info-card__label">Total for {{ date }}</p>
            <p class="info-card__value tabular" v-if="details && details.totalAmountByDate">
              {{ currency(details.totalAmountByDate.totalAmount) }}
            </p>
            <p class="info-card__value tabular" v-else>GHS 0.00</p>
          </div>
        </div>
      </v-col>
    </v-row>

    <div class="d-flex align-center mb-3 mt-4">
      <h2 class="section-title mb-0">Transactions</h2>
      <v-spacer />
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            v-bind="attrs"
            v-on="on"
            class="toolbar-btn text-none"
            :class="{ 'toolbar-btn--active': date !== null }"
          >
            <v-icon small left>mdi-calendar-range-outline</v-icon>
            {{ date ? date : "Choose date" }}
            <v-icon v-if="date !== null" small right @click.stop="date = null"
              >mdi-close</v-icon
            >
          </v-btn>
        </template>
        <v-date-picker v-model="date" color="primary" @input="menu = false" />
      </v-menu>
    </div>

    <v-data-table
      :loading="pageLoading"
      :headers="headers"
      :options.sync="options"
      :server-items-length="pagination.total"
      :items="transactions"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
      class="data-table"
    >
      <template #item.createdAt="{ item }">
        <span class="text-muted">{{ item.createdAt | timestamp }}</span>
      </template>
      <template #item.memberId="{ item }">
        <span class="cell-strong text-capitalize"
          >{{ item.memberId && item.memberId.lastName }}
          {{ item.memberId && item.memberId.firstName }}</span
        >
      </template>
      <template #item.totalAmount="{ item }">
        <span class="tabular cell-strong">{{ currency(item.totalAmount) }}</span>
      </template>
      <template #item.service="{ item }">
        <span class="pill pill--brand text-uppercase">{{ item.service }}</span>
      </template>
    </v-data-table>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>
<script>
// import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    SnackBar: loadComponent(`component/SnackBar`),
    Breadcrumbs: loadComponent(`component/Breadcrumbs`)
  },
  computed: {
    ...mapGetters({
      pageLoading: "getIsPageLoading",
      details: "staffs/getStaffDetails",
      transactions: "staffs/getAllTransactions",
      pagination: "staffs/getPagination"
    })
  },
  mixins: [SnackBarMixins],
  data() {
    return {
      tab: 0,
      menu: false,
      date: null,
      staff: {
        name: "",
        phone: "",
        accountNumber: ""
      },
      headers: [
        { text: "Date", value: "createdAt" },
        { text: "Member", value: "memberId" },
        { text: "Acc/No.", value: "accountNumber" },
        { text: "Amt.", value: "totalAmount" },
        { text: "Service", value: "service" }
      ],
      options: {}
    };
  },
  filters: {
    timestamp(value) {
      return moment(value).format("YYYY-MM-DD HH:mm A");
    }
  },
  watch: {
    details(payload) {
      const { name, phone, accountNumber } = payload;
      this.staff = { name, phone, accountNumber };
    },
    date(value) {
      this.$store.dispatch("staffs/transactions", {
        id: this.$route.query.id,
        query: `?page=1&size=${this.options.itemsPerPage ?? 10}${
          value ? "&date=" + value : ""
        }`
      });
    },
    options(option) {
      const { itemsPerPage, page } = option;
      this.$store.dispatch("staffs/transactions", {
        id: this.$route.query.id,
        query: `?page=${page}&size=${itemsPerPage}${
          this.date ? "&date=" + this.date : ""
        }`
      });
    }
  },
  methods: {
    currency(value) {
      return new Intl.NumberFormat("en-GB", {
        currency: "GHS",
        style: "currency",
        minimumFractionDigits: 2
      }).format(value || 0);
    },
    addNewStaff() {
      if (this.$route.query.id) {
        this.$store.dispatch("staffs/update", {
          _id: this.$route.query.id,
          ...this.staff
        });
        return;
      }
      this.$store.dispatch("staffs/create", {
        ...this.staff
      });
    }
  },
  created() {
    if (this.$route.query.id) {
      this.$store.dispatch("staffs/transactions", {
        id: this.$route.query.id,
        query: `?page=1&size=10`
      });
    }
  }
};
</script>

<style scoped>
.info-card {
  display: flex;
  gap: 14px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-card);
  padding: 18px 20px;
  height: 100%;
}
.info-card__avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--signal-soft);
}
.info-card__avatar .v-icon {
  color: var(--signal);
}
.info-card__avatar--success {
  background: var(--status-delivered-soft);
}
.info-card__avatar--success .v-icon {
  color: var(--status-delivered);
}
.info-card__avatar--info {
  background: var(--status-sent-soft);
}
.info-card__avatar--info .v-icon {
  color: var(--status-sent);
}
.info-card__name {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: var(--foreground);
  letter-spacing: 0.02em;
}
.info-card__line {
  margin: 0 0 2px;
  font-size: 13px;
  display: flex;
  gap: 8px;
}
.info-card__line .tabular {
  color: var(--foreground);
  font-weight: 500;
}
.info-card__label {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 500;
  color: var(--muted-foreground);
}
.info-card__value {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 20px;
  font-weight: 600;
  color: var(--foreground);
}
.toolbar-btn {
  border-color: var(--border) !important;
  color: var(--muted-foreground) !important;
  border-radius: var(--radius) !important;
  height: 40px !important;
  font-weight: 500;
}
.toolbar-btn--active {
  border-color: var(--signal) !important;
  color: var(--signal) !important;
}
.cell-strong {
  font-weight: 600;
  color: var(--foreground);
}
.text-muted {
  color: var(--muted-foreground);
}
</style>
